import type { ManualDasConfigurationSwitchDto } from "../../types/ManualDasConfigurationSwitchDto";
import type { ManualDasConfigurationSwitchEntity } from "../../types/ManualDasConfigurationSwitchEntity";

export const ManualDasConfigurationSwitchEntityToDto = ({
    ...rest
}: Readonly<ManualDasConfigurationSwitchEntity>): ManualDasConfigurationSwitchDto => {
    return { ...rest };
};
